import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import {BloggerGroupsService} from "../services/blogger-groups.service";
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AttachDetachBloggersByGroup, BloggerGroupsData} from "../types/blogger-groups.types";
import {BloggerGroupsStateService} from "../services/blogger-groups-state.service";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption} from "@angular/material/core";
import {MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {detachBloggerGroupsModalName} from "../configs/detach-blogger-groups-config";
import {LoaderComponent} from "../../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-detach-blogger-groups-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    FormsModule,
    MatButton,
    LoaderComponent
  ],
  templateUrl: './detach-blogger-groups-modal.component.html',
  styleUrl: './detach-blogger-groups-modal.component.scss'
})
export class DetachBloggerGroupsModalComponent extends BaseModalComponent {
  private detachBloggerGroupsDialogData = inject<number>(MAT_DIALOG_DATA);
  private bloggerGroupsService: BloggerGroupsService = inject(BloggerGroupsService);
  private bloggerGroupsStateService: BloggerGroupsStateService = inject(BloggerGroupsStateService);

  public bloggerGroups: Array<BloggerGroupsData> = [];
  public selectedGroup: number = 0;

  public override async ngOnInit() {
    super.ngOnInit();
    this.modalStatesService.openModal(detachBloggerGroupsModalName);
    this.loadingService.setIsLoadingState(true);
    await this.bloggerGroupsService.getBloggerGroupsData(this.detachBloggerGroupsDialogData);
    this.bloggerGroups = this.bloggerGroupsStateService.bloggerGroups();
    this.loadingService.setIsLoadingState(false);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(detachBloggerGroupsModalName);
  }

  public async handleDetach(): Promise<void> {
    if (!this.selectedGroup) {
      this.errorService.showErrorMessage('Выберите группу');
      return;
    }

    this.loadingService.setIsLoadingState(true);
    const attachDetachBloggersByGroup: AttachDetachBloggersByGroup = {
      id: this.selectedGroup,
      bloggerIds: [ this.detachBloggerGroupsDialogData ]
    };

    await this.bloggerGroupsService.detachBloggersByGroup(attachDetachBloggersByGroup)
      .then(() => this.snackbarService.showMessage({ message: 'Блогер откреплён от группы' }))
      .finally(() => {
        this.loadingService.setIsLoadingState(false);
        this.closeDialog('cancel');
      });
  }
}
